import React, { useEffect } from 'react';
import { Form, Select } from 'antd';
import { filedNames } from '../../constants';
import useInfoTypes from '../../../../queries/useInfoTypes';
import { getInfoTypeIcon } from '../../../../utils';
import styles from './TypeField.module.scss';

const TypeField = ({ form, initialValue }) => {
  const { data: types, isFetching } = useInfoTypes({ staleTime: Infinity });

  const { getFieldDecorator, setFieldsValue } = form;

  useEffect(() => {
    if (!isFetching && initialValue) {
      setFieldsValue({ [filedNames.typeId]: initialValue });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching, initialValue]);

  return (
    <Form.Item
      label="Тема"
      colon={false}
    >
      {getFieldDecorator(filedNames.typeId, {
        initialValue: isFetching ? undefined : initialValue,
        rules: [{ required: true, message: 'Выберите тему информирования' }],
      })(
        <Select
          className={styles.root}
          loading={isFetching}
          showSearch
          placeholder="Тема информирования"
          optionFilterProp="searchtext"
        >
          {types?.map((type) => (
            <Select.Option
              key={type.id}
              value={type.id}
              searchtext={type.name}
            >
              <div className={styles.option}>
                {getInfoTypeIcon(type.id, 16)}
                {type.name}
              </div>
            </Select.Option>
          ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default TypeField;
